import { useState, useEffect } from 'react'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusReleaseNotesInnerview } from '@rhybus/releasenotes'
import { RhyBusNoresult } from '@rhybus/noresult'
import { convertDate, removehtmltags } from '@rhybus/common-functions'
import { RhyBusCard } from '@rhybus/card'
import { releaseNotesInnerViewConfig } from '../../config/configuration'
import { getReleaseNotesItems, ReleaseNoteItem } from '../../services/releaseNotes'

export default function ReleaseNotes() {
    const [items, setItems] = useState<ReleaseNoteItem[]>([])

    useEffect(() => {
        getReleaseNotesItems().then((data: ReleaseNoteItem[]) => {
            setItems(data.map((item) => ({
                ...item,
                title: item.VersionName,
                NewFeatures: removehtmltags(item.NewFeatures),
                ResolvedIssues: removehtmltags(item.ResolvedIssues),
                KnownIssues: removehtmltags(item.KnownIssues),
                ReleaseDate: convertDate(item.ReleaseDate, 'date')
            })))
        }).catch((err) => {
            console.error('[ReleaseNotes] fetch error:', err)
        })
    }, [])

    return (
        <main id="main-content">
            <RhyBusPageHeader pageTitle={'Release Notes'} pageHeaderIcon="icon-rb-file-text-earmark" />
            <div className='container'>
                {items.length === 0
                    ? <RhyBusCard cardSize='lg' cardBody={<RhyBusNoresult />}/>
                    : <RhyBusReleaseNotesInnerview
                        items={items}
                        detailConfig={releaseNotesInnerViewConfig}
                    />
                }
            </div>
        </main>
    )
}